import I18n from 'i18n-js';
import { socialMedia } from 'config';
import facebookIcon from 'assets/images/socialMediaIcons/facebook.svg';
import facebookIconFooter from 'assets/images/socialMediaIcons/facebookMin.svg';
import twitterIcon from 'assets/images/socialMediaIcons/twitter.svg';
import twitterIconFooter from 'assets/images/socialMediaIcons/twitterMin.svg';
import youtubeIcon from 'assets/images/socialMediaIcons/youtube.svg';
import youtubeIconFooter from 'assets/images/socialMediaIcons/youtubeMin.svg';

export default function SocialMediaIcons({
	footer = false,
}: {
	footer?: boolean;
}) {
	const Icons: { src: string; alt: string }[] = [
		{ src: !footer ? facebookIcon : facebookIconFooter, alt: 'facebook' },
		{ src: !footer ? twitterIcon : twitterIconFooter, alt: 'twitter' },
		{ src: !footer ? youtubeIcon : youtubeIconFooter, alt: 'youtube' },
	];
	return (
		<>
			{Icons.map(({ src, alt }) => (
				<a target='_blank' rel='noreferrer' key={alt} href={socialMedia[alt]}>
					<img src={src} alt={I18n.t(alt)} />
				</a>
			))}
		</>
	);
}
